import { createAction } from '@reduxjs/toolkit';

const resetCache = createAction('RESET_CACHE', () => ({ payload: null }));

export default resetCache;
